<template>
  <div class="bottom-bar-container">
    <app-card
      class="bottom-bar"
      border-bottom-radius="0"
      minimal-vertical-padding
      top-shadow
    >
      <app-navbar>
        <app-navbar-item class="btn" :active="isActiveHome">
          <router-link :to="{ name: 'selectCompany', params: $route.params }">
            <app-icon
              class="icon"
              src="images/icons/observatory.svg"
              :size="iconSize"
            />

            <small class="caption">Home</small>
          </router-link>
        </app-navbar-item>

        <app-navbar-item class="btn" :active="isActiveSearch">
          <router-link :to="{ name: 'search', params: $route.params }">
            <app-icon
              class="icon"
              src="images/icons/search2.svg"
              :size="iconSize"
            />

            <small class="caption">Buscar</small>
          </router-link>
        </app-navbar-item>

        <app-navbar-item
          class="btn"
          @click="app.showUserSidebar"
          :active="isActiveUserSidebar"
        >
          <app-icon
            class="icon"
            src="images/icons/astronaut.svg"
            :size="iconSize"
          />
          <small class="caption">Perfil</small>
        </app-navbar-item>

        <app-navbar-item class="btn" :active="isActiveContact">
          <router-link :to="{ name: 'contact', params: $route.params }">
            <app-icon
              class="icon"
              src="images/icons/satellite.svg"
              :size="iconSize"
            />

            <small class="caption">Contato</small>
          </router-link>
        </app-navbar-item>
      </app-navbar>
    </app-card>
  </div>
</template>

<script>
export default {
  name: 'BottomBar',

  props: {
    iconSize: {
      type: String,
      default: '32px',
    },
  },

  computed: {
    isActiveHome() {
      return ['selectCompany'].includes(this.$route.name)
    },

    isActiveSearch() {
      return ['search'].includes(this.$route.name)
    },

    isActiveUserSidebar() {
      return app.isActiveUserSidebar
    },

    isActiveContact() {
      return ['contact'].includes(this.$route.name)
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@import '@/styles/settings.scss';

.bottom-bar {
  $padding: math.div($defaultPadding, 5);

  padding: $padding $padding max($padding, env(safe-area-inset-bottom)) !important;
}

.btn {
  padding-top: 0 !important;
  padding-bottom: 0 !important;

  &::after {
    display: none !important;
  }

  .caption {
    display: block;
    font-size: 75%;
    line-height: 100%;
    margin-top: 0.25em;
  }
}

.app-navbar-item {
  &,
  a {
    width: 100%;
    text-align: center;
    color: inherit;
    text-decoration: none;
  }
}

.icon {
  margin: auto;
}
</style>
